import React, { Component } from 'react'
import styles from './styles.scss'

import { TimelineMax, TweenMax, Power3, Cubic, Expo } from 'gsap'
import SplitText from 'utils/gsapPlugins/SplitText.min'

import Scroller from 'src/utils/scroller'
import raf from 'src/utils/raf'
import resize from 'src/utils/resize'
import values from 'src/values'

import ImgItem from './components/img-item'
import components from 'src/utils/components'

export default class WallWrapper extends Component {
  constructor(props) {
    super(props)

    this.itemSizes = {
      desktop: { w: 250, h: 250 },
      mobile: { w: 150, h: 150 }
    }

    this.state = {
      items: [],
      sizes: {}
    }

    this.currentWall = 0
    this.key = 'wallWrapper'
  }

  componentDidMount() {
    this.initTL()
    this.onResize()
    resize.add(this.onResize, this.key)
    raf.add(this.onRAF)

    Scroller.updateScrollHeight()
  }

  componentDidUpdate() {
    this.setWall()

    this.isResizing = false
    Scroller.updateScrollHeight()
    components.allComponents.footer.onResize()
  }

  componentWillUnMount() {
    resize.remove(this.onResize, this.key)
    raf.remove(this.onRAF)
  }

  setWall() {
    if (
      !this.refs.wallMainWrapper ||
      !this.state.items ||
      !this.state.items[this.currentWall]
    )
      return

    if (this.refs[`previous${this.currentWall}`])
      TweenMax.set(this.refs[`previous${this.currentWall}`], { autoAlpha: 1 })

    if (this.refs[`next${this.currentWall}`])
      TweenMax.set(this.refs[`next${this.currentWall}`], { autoAlpha: 1 })

    TweenMax.to(this.refs.wallMainWrapper, 0.5, {
      x:
        this.currentWall === 0
          ? -this.marginLeftWallMainWrapper
          : -(values.viewport.width * (this.currentWall - 1)) -
            this.state.items[this.currentWall].length * this.state.sizes.w -
            50,
      ease: Expo.easeOut
    })
  }
  initTL() {
    this.tlAnimateIn = new TimelineMax({
      paused: true,
      onStart: () => {
        this.tlAnimateInIsPlaying = true
      },
      onComplete: () => {
        this.tlAnimateInIsEnded = true
      }
    })

    this.tlAnimateIn.fromTo(
      this.refs.component,
      1,
      {
        opacity: 0
      },
      {
        opacity: 1
      },
      0
    )
  }

  resetTL() {
    this.tlAnimateInIsPlaying = false
    this.tlAnimateInIsEnded = false
    this.tlAnimateIn.paused()
    this.tlAnimateIn.progress(0)
  }

  onResize = () => {
    if (!this.refs.component) return

    this.isResizing = true
    const $component = this.refs.component.getBoundingClientRect()

    this.topComponent = $component.top + values.scroll.currentY

    this.xOffset = $component.left
    this.hComponent = this.refs.component.offsetHeight
    this.wComponent = this.refs.component.offsetWidth

    const $wallMainWrapper = this.refs.wallMainWrapper.getBoundingClientRect()
    this.topWallMainWrapper = $wallMainWrapper.top + values.scroll.currentY
    this.leftWallMainWrapper = $wallMainWrapper.left

    this.marginLeftWallMainWrapper = this.leftWallMainWrapper - 10

    if (this.resizeStop) {
      clearTimeout(this.resizeStop)
      this.resizeStop = null
    }

    this.resizeStop = setTimeout(this.wallGenerator, 10)
  }

  onRAF = () => {
    if (!this.refs.component) return

    this.perc =
      (values.scroll.currentY + values.viewport.height - this.topComponent) /
      (values.viewport.height + this.hComponent)

    this.perc >= 0.1 &&
      !this.tlAnimateInIsEnded &&
      !this.tlAnimateInIsPlaying &&
      this.tlAnimateIn.play(0)

    this.perc <= -0.6 && this.resetTL()
  }

  wallGenerator = () => {
    const sizes = this.itemSizes.desktop
    this.column = Math.ceil(values.viewport.width / sizes.w) - 1

    this.viewportItems = []
    let viewportIterator = 0
    let columnIterator = 0

    this.props.items.map((item, i) => {
      if (!this.viewportItems[viewportIterator])
        this.viewportItems[viewportIterator] = []

      if (!this.viewportItems[viewportIterator][columnIterator])
        this.viewportItems[viewportIterator][columnIterator] = []

      this.viewportItems[viewportIterator][columnIterator].push(item)

      if (this.viewportItems[viewportIterator].length === this.column) {
        columnIterator = 0
        viewportIterator += 1
      } else if (
        (((columnIterator === 0 && viewportIterator === 0) ||
          columnIterator === this.column) &&
          this.viewportItems[viewportIterator][columnIterator].length > 0) ||
        this.viewportItems[viewportIterator][columnIterator].length === 2
      ) {
        columnIterator += 1
      }
    })

    this.setState({
      items: this.viewportItems,
      sizes: sizes
    })
  }

  moveWall(next, current) {
    let translateX

    if (next === 0) {
      translateX = -this.marginLeftWallMainWrapper
    } else {
      let xSlider = values.viewport.width

      this.state.items.map((item, i) => {
        if (i > next) return
        xSlider -= this.state.items[i].length * this.state.sizes.w
      })

      translateX = xSlider - this.marginLeftWallMainWrapper - 20
    }

    TweenMax.to(this.refs.wallMainWrapper, 2.5, {
      x: translateX,
      ease: Expo.easeOut
    })

    if (this.refs[`previous${current}`])
      TweenMax.to(this.refs[`previous${current}`], 0.3, {
        autoAlpha: 0,
        ease: Expo.easeOut
      })

    if (this.refs[`next${current}`])
      TweenMax.to(this.refs[`next${current}`], 0.3, {
        autoAlpha: 0,
        ease: Expo.easeOut
      })

    if (this.refs[`previous${next}`])
      TweenMax.to(this.refs[`previous${next}`], 0.5, {
        autoAlpha: 1,
        delay: 2,
        ease: Expo.easeOut
      })

    if (this.refs[`next${next}`])
      TweenMax.to(this.refs[`next${next}`], 0.5, {
        autoAlpha: 1,
        delay: 2,
        ease: Expo.easeOut
      })

    this.currentWall = next
  }

  render() {
    return (
      <div ref="component" className="component wall-wrapper">
        <div
          className="wall-main-wrapper"
          style={{
            width: this.state.items[0]
              ? values.viewport.width * (this.state.items.length - 1) +
                this.state.items[this.state.items.length - 1].length *
                  this.state.sizes.w
              : 0
          }}
          ref="wallMainWrapper">
          {this.state.items.map((wall, i) => {
            return (
              <div
                key={`wallContainer${i}`}
                ref={`wallContainer${i}`}
                className={`wall-container wall-container-${i}`}>
                <div className="wall-columns-wrapper">
                  {wall.map((columns, x) => {
                    return (
                      <div
                        key={`column${x}wall${i}`}
                        ref={`column${x}wall${i}`}
                        className="wall-column">
                        {columns.map((item, y) => {
                          return (
                            <ImgItem
                              walls={this.state.items}
                              wall={i}
                              column={x}
                              item={y}
                              key={`img${y}column${x}wall${i}`}
                              ref={`img${y}column${x}wall${i}`}
                              sizes={this.state.sizes}
                              data={item}
                            />
                          )
                        })}
                        {x === 0 || x === this.column - 1 ? (
                          x === 0 ? (
                            x === 0 && i != 0 ? (
                              <div
                                className="cta previous-cta"
                                onClick={this.moveWall.bind(this, i - 1, i)}
                                ref={`previous${i}`}>
                                <h4>{this.props.previous}</h4>
                                <span className="arrow">
                                  <span className="middle" />
                                  <span className="top" />
                                  <span className="btm" />
                                </span>
                              </div>
                            ) : null
                          ) : i != this.state.items.length - 1 ? (
                            <div
                              className="cta next-cta"
                              onClick={this.moveWall.bind(this, i + 1, i)}
                              ref={`next${i}`}>
                              <h4>{this.props.next}</h4>
                              <span className="arrow">
                                <span className="middle" />
                                <span className="top" />
                                <span className="btm" />
                              </span>
                            </div>
                          ) : null
                        ) : null}
                      </div>
                    )
                  })}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home/components/wall/components/wall-wrapper/index.js